import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const DeleteFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M5.45 7.66c-.19 0-.35.17-.33.36l1.33 12.42c.1.9.89 1.58 1.83 1.58h7.43c.94 0 1.73-.68 1.83-1.58l1.33-12.42a.328.328 0 0 0-.33-.36H5.45Zm5.53 9.3c0 .44-.36.8-.8.8-.44 0-.8-.36-.8-.8v-5.88c0-.44.36-.8.8-.8.44 0 .8.36.8.8v5.88Zm3.45-.04c0 .44-.36.8-.8.8-.44 0-.8-.36-.8-.8v-5.88c0-.44.36-.8.8-.8.44 0 .8.36.8.8v5.88ZM20.21 5.04h-3.72l-.52-1.37a2.298 2.298 0 0 0-2.14-1.48h-3.79c-.94 0-1.8.59-2.14 1.48l-.52 1.37H3.79c-.44 0-.8.36-.8.8 0 .44.36.8.8.8h16.42c.44 0 .8-.36.8-.8 0-.44-.36-.8-.8-.8ZM9.4 4.24c.1-.27.36-.44.64-.44h3.79c.28 0 .54.18.64.44l.24.65H9.15l.24-.65h.01Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default DeleteFilled
